import Vue from 'vue'
import jsonwebtoken from 'jsonwebtoken'

Vue.prototype.$jwt = jsonwebtoken
